
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/alipay/auth/success",
      function () {
        return require("private-next-pages/[locale]/alipay/auth/success/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/alipay/auth/success"])
      });
    }
  